import {config, request, objectSerial} from 'Utils';

/*获取购销单位数据*/
export function getGouXiaoUnitList(param) {
    return request(`${config.server}/api/v1/dms/dmsPurchase/list`, {
        method: 'post',
        body: {...param}
    });
}

export function deleterRecord(param) {
    return request(`${config.server}/api/v1/dms/tgSpecialOrderHeader/delete`, {
        method: 'get',
        body: {...param}
    });
}


/*获取订单列表数据*/
export function getTgSpecialOrderList(param) {
    return request(`${config.server}/api/v1/dms/tgSpecialOrderHeader/list`, {
        method: 'post',
        body: {...param}
    });
}

/*获取选择物料数据*/
export function getItemList(param) {
    return request(`${config.server}/api/v1/dms/tgSpecialOrderHeader/itemList`, {
        method: 'post',
        body: {...param}
    });
}

/*提交订单数据*/
export function submitSpecialOrder(param) {
    return request(`${config.server}/api/v1/dms/tgSpecialOrderHeader/submitSpecialOrder`, {
        method: 'post',
        body: {...param}
    });
}

export function saveSpecialOrder(param) {
    return request(`${config.server}/api/v1/dms/tgSpecialOrderHeader/saveSpecialOrder`, {
        method: 'post',
        body: {...param}
    });
}

/*获取详情*/
export function getSpecialOrderDetail(id) {
    return request(`${config.server}/api/v1/dms/tgSpecialOrderHeader/detail?id=${id}`, {
        method: 'get',
    });
}

//特价获取
export function getSpecialList(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/specialList2`, {
        method: 'post',
        body: param,
    });
}

//特价详情
export function getSpecialDetail(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/specialLineList`, {
        method: 'post',
        body: param,
    });
}

//获取特殊订单类型
export function getSpecialType() {
    return request(`${config.server}/api/v1/dms/tgSpecialOrderHeader/getSpecialType`, {
        method: 'get'
    });
}

/*项目订单特价传值*/
export function giveTeJia(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/selectProSpecial`, {
        method: 'post',
        body: param,
    });
}

/*批量获取特价行*/
export function giveTeJia2(param) {
    return request(`${config.server}/api/v1/dms/tgOrder/selectProSpecial2`, {
        method: 'post',
        body: param,
    });
}

/*项目订单选择合同/订单类型-完成*/
export function getContract(param) {
    return request(`${config.server}/api/v1/dms/dmsErpCredit/directSellContract`, {
        method: 'post',
        body: param,
    });
}


// WEBPACK FOOTER //
// ./src/service/specialOrder/index.js